import { render, staticRenderFns } from "./descTable.vue?vue&type=template&id=7791152a&scoped=true"
import script from "./descTable.vue?vue&type=script&lang=js"
export * from "./descTable.vue?vue&type=script&lang=js"
import style0 from "./descTable.vue?vue&type=style&index=0&id=7791152a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7791152a",
  null
  
)

export default component.exports